import { useMemo } from "react";
import { useAppContext } from "../context/appContext";
import { useAuthContext } from "../context/authContext";
import { useNotificationsApi } from "../http/useNotifications";
import { NotificationEntry, toNotificationEntries } from "../utils/notifications";
import useI18n from "./useTranslations";

/** What waits for the signed-in user, as menu entries: none while nothing does */
const useNotificationEntries = (): NotificationEntry[] => {
  const i18n = useI18n();
  const { identity } = useAuthContext();
  const { isSingleModuleApp } = useAppContext();
  const notificationsApi = useNotificationsApi();

  const { data } = notificationsApi.useNotifications(!!identity);

  return useMemo(
    () => toNotificationEntries(data?.items ?? [], i18n.translation, isSingleModuleApp),
    [data, i18n.translation, isSingleModuleApp],
  );
};

export default useNotificationEntries;
